import React from 'react';
import {withStyles, Tab, createStyles} from '@material-ui/core';
import {Theme} from '@material-ui/core/styles';
import {BLACK_COLOR, SWITCH_BORDER_COLOR, APP} from '../../../style/variable';

interface StyledTabProps {
  label: React.ReactNode;
  disabled?: boolean;
  value?: string;
}
const InvoicesTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'none',
      fontWeight: theme.typography.fontWeightMedium as number,
      fontSize: '1rem',
      marginRight: theme.spacing(1),
      color: BLACK_COLOR,
      opacity: 1,
      display: 'flex',
      fontFamily: APP.FONT_FAMILY.REGULAR,
      minHeight: '35px',
      '&:focus': {
        color: SWITCH_BORDER_COLOR
      },
      '& .MuiTab-wrapper': {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center'
      }
    },
    selected: {
      fontSize: '1rem',
      color: SWITCH_BORDER_COLOR
    }
  })
)((props: StyledTabProps) => <Tab {...props} />);

export default InvoicesTab;
